// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBO7G8QS8uv4CRB_50v5240FjXSG8o2zno",
  authDomain: "articulate-bot-204510.firebaseapp.com",
  projectId: "articulate-bot-204510",
  storageBucket: "articulate-bot-204510.firebasestorage.app",
  messagingSenderId: "661621432041",
  appId: "1:661621432041:web:390a06d0985dfee877da78"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };